import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import React from 'react';

const styles = {
  collapseHeader: {
    backgroundColor: 'primary.main',
  },
  collapseText: {
    color: 'grey.50',
    pl: 1,
  },
  icon: {
    color: 'grey.50',
  },
  unCollapseHeader: {
    px: 0,
    py: 1,
  },
};

interface ISectionHeaderProps {
  children?: React.ReactNode | null;
  headerText: React.ReactElement;
  onCollapse?: () => void;
  open?: boolean;
  variant?:
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'subtitle1'
    | 'subtitle2'
    | 'body1'
    | 'body2'
    | 'caption'
    | 'button'
    | 'overline'
    | 'inherit';
}

export function SectionHeader({
  children = null,
  headerText,
  onCollapse,
  open = false,
  variant = 'subtitle1',
}: ISectionHeaderProps) {
  return (
    <Box py={1}>
      {onCollapse ? (
        <Box sx={styles.collapseHeader}>
          <Grid alignItems="center" container direction="row" justifyContent="center">
            <Grid size="grow">
              <Typography sx={styles.collapseText} variant={variant}>
                {headerText}
              </Typography>
            </Grid>
            <Grid size="grow">{children}</Grid>
            <Grid size={{ xs: 1 }}>
              <Grid alignItems="center" container direction="row" justifyContent="flex-end">
                <Grid>
                  <Box px={1}>
                    <IconButton onClick={onCollapse}>
                      {open ? <ExpandLess sx={styles.icon} /> : <ExpandMore sx={styles.icon} />}
                    </IconButton>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      ) : (
        <>
          <Grid alignItems="center" container direction="row" justifyContent="center">
            <Grid size="grow">
              <Typography noWrap sx={styles.unCollapseHeader} variant={variant}>
                {headerText}
              </Typography>
            </Grid>
            <Grid size="grow">{children}</Grid>
          </Grid>
          <Divider />
        </>
      )}
    </Box>
  );
}
